import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../../utils/api";

// Asigna usuario a plantilla de archivos
export const assignUserToForm = createAsyncThunk(
  "formsubmitted/assignUserToForm",
  async ({ template, user }: { template: string; user: string }, { rejectWithValue }) => {
    try {
      // Crea registros
      if (template && user) {
        const url = new URL(`${api.baseURL}formsubmitted`);
        const token = localStorage.getItem("token");
        const headers = new Headers();
        headers.append("Authorization", `Bearer ${token}`);
        headers.append("Content-Type", "application/json");

        const response = await fetch(url.toJSON(), {
          body: JSON.stringify({
            form: template,
            user: user,
          }),
          method: "POST",
          headers: headers,
        });
        if (!response.ok) {
          throw response.statusText;
        }
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
